import React from "react";

export default function LoginWithProconnect() {
  return (
    <div className="app-search_cnx_requise">
      <div className="app-search__wrapper">
        <div className="container is-fullhd">
          <strong>
            <p>Ecran temporaire pour test</p> Pour vous connecter au portail via
            ProConnect, veuillez cliquer sur le bouton « S’identifier avec
            Proconnect » en haut à droite de cet écran.
          </strong>
        </div>
      </div>
    </div>
  );
}
